import { Deserializable } from "../deserializable";

export class UserBasicDetails implements Deserializable {

    id: number;
    fullName: string;
    displayName: string;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
      }
}